import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

const TOKEN_KEY = "consultant_os_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (token) => localStorage.setItem(TOKEN_KEY, token);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);
export const authHeaders = () => {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const login = (pin) => api.post("/auth/login", { pin }).then((r) => r.data);
export const verifyAuth = () => api.get("/auth/verify").then((r) => r.data);

export const getStats = () => api.get("/user/stats").then((r) => r.data);
export const setMoodEnergy = (mood, energy) =>
  api.post("/user/mood-energy", { mood, energy }).then((r) => r.data);
export const getSchedule = () => api.get("/schedule/today").then((r) => r.data);
export const createScheduleBlock = (payload) =>
  api.post("/schedule/block", payload).then((r) => r.data);
export const updateScheduleBlock = (id, payload) =>
  api.patch(`/schedule/block/${id}`, payload).then((r) => r.data);
export const deleteScheduleBlock = (id) =>
  api.delete(`/schedule/block/${id}`).then((r) => r.data);
export const getRoadmap = () => api.get("/roadmap").then((r) => r.data);
export const updateTopic = (id, status) =>
  api.patch(`/roadmap/topic/${id}`, { status }).then((r) => r.data);
export const createTopic = (payload) =>
  api.post("/roadmap/topic", payload).then((r) => r.data);
export const updateTopicDetails = (id, payload) =>
  api.patch(`/roadmap/topic/${id}/details`, payload).then((r) => r.data);
export const deleteTopic = (id) =>
  api.delete(`/roadmap/topic/${id}`).then((r) => r.data);
export const startSession = (work_type, goal) =>
  api.post("/session/start", { work_type, goal }).then((r) => r.data);
export const endSession = (payload) =>
  api.post("/session/end", payload).then((r) => r.data);
export const recentSessions = () =>
  api.get("/sessions/recent").then((r) => r.data);
export const saveJournal = (payload) =>
  api.post("/journal", payload).then((r) => r.data);
export const getJournalToday = () =>
  api.get("/journal/today").then((r) => r.data);
export const getJournalRecent = (limit) =>
  api.get("/journal/recent", { params: limit ? { limit } : {} }).then((r) => r.data);
export const getChatHistory = (session_id) =>
  api.get("/assistant/history", { params: session_id ? { session_id } : {} }).then((r) => r.data);

// SSE streaming chat
export function streamChat(message, sessionId, onDelta, onSession, onDone, onError) {
  const controller = new AbortController();
  fetch(`${API}/assistant/chat`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeaders() },
    body: JSON.stringify({ message, session_id: sessionId }),
    signal: controller.signal,
  }).then(async (resp) => {
    if (!resp.ok || !resp.body) {
      onError && onError(new Error(`HTTP ${resp.status}`));
      return;
    }
    const reader = resp.body.getReader();
    const decoder = new TextDecoder();
    let buffer = "";
    while (true) {
      const { value, done } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });
      const parts = buffer.split("\n\n");
      buffer = parts.pop() || "";
      for (const p of parts) {
        const line = p.trim();
        if (!line.startsWith("data:")) continue;
        const data = line.slice(5).trim();
        if (data === "[DONE]") { onDone && onDone(); return; }
        try {
          const obj = JSON.parse(data);
          if (obj.session_id) onSession && onSession(obj.session_id);
          if (obj.delta) onDelta && onDelta(obj.delta);
          if (obj.error) onError && onError(new Error(obj.error));
        } catch { /* ignore */ }
      }
    }
    onDone && onDone();
  }).catch((e) => onError && onError(e));
  return () => controller.abort();
}
